import React, { createContext, useState } from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './pages';
import AddProduct from './pages/add-product/Index';
import Success from './pages/success';

export const GlobalContext = createContext(null);

const App = () => {
  const [products, setProducts] = useState({});

  return (
    <GlobalContext.Provider value={{ products, setProducts }}>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/add-product/:category" component={AddProduct} />
        <Route path="/success" component={Success} />
      </Switch>
    </GlobalContext.Provider>
  );
};

export default App;
